import React from "react";
import { type AnswerPropsBase } from "features/Library/Common/QuestionsForm/types";
import { TextAnswer } from "features/Library/Common/QuestionsForm/Answers/AnswerFields/TextAnswer";

type Props = AnswerPropsBase<string>;

export const SurveyTextAnswer = (props: Props) => {
  const { index, answer, onBlur, disabled, validatedFieldProps, propertyNamePrefix, onChanged } = props;

  const propertyName = `${propertyNamePrefix}answer`;

  return (
    <TextAnswer
      index={index}
      onBlur={onBlur}
      onChanged={onChanged}
      validatedFieldProps={validatedFieldProps}
      answer={answer.answer}
      answerFieldPropertyName={propertyName}
      disabled={disabled}
    />
  );
};
